import { HOW_CONNECT_DISCOUNT } from 'shared/constants/howConnectDiscount';
import { Title } from '../Title';
import * as style from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { IHowConnectDiscountItem } from 'shared/types/howConnectDiscount';

interface IHowConnectDiscountProps {
  buttonLink: JSX.Element;
  Item: React.FC<IHowConnectDiscountItem>;
}

export const HowConnectDiscount: React.FC<IHowConnectDiscountProps> = ({ buttonLink, Item }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], style[device])}>
      <Title>Как подключить скидку на ипотеку?</Title>
      <div className={style['list']}>
        {HOW_CONNECT_DISCOUNT.map(item => (
          <Item {...item} key={item.id} />
        ))}
      </div>
      <div className={style['btn']}>{buttonLink}</div>
    </div>
  );
};
